import { render, staticRenderFns } from "./BBadge.vue?vue&type=template&id=7c8ca1d7&"
import script from "./BBadge.vue?vue&type=script&lang=js&"
export * from "./BBadge.vue?vue&type=script&lang=js&"
import style0 from "./BBadge.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports